import { DropdownOption, DropdownOptionType } from '@ardoq/dropdown-menu';
import { TabProps, TabsGroupProps } from './types';
import { Tag } from '@ardoq/status-ui';
import { FlexBox } from '@ardoq/layout';
import { PlainTextPopover, WithUncontrolledPopover } from '@ardoq/popover2025';
import { ICON_SELECTOR, Icon } from '@ardoq/icons';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';

const TabLabelWrapper = styled(FlexBox).attrs({ gap: 'small' })`
  ${ICON_SELECTOR} {
    color: ${colors.iconAction};
  }
`;

export const tabPropsToDropdownOption = (
  {
    label,
    tabId,
    clickId,
    statusType,
    badgeTooltipText,
    rightIconName,
    rightIconPopoverMessage,
  }: TabProps,
  {
    onTabChange,
    activeTabId,
  }: Pick<TabsGroupProps, 'onTabChange' | 'activeTabId'>
): DropdownOption => ({
  label: (
    <TabLabelWrapper>
      {label}
      {badgeTooltipText && (
        <Tag label={badgeTooltipText} statusType={statusType} />
      )}
      {rightIconName && (
        <WithUncontrolledPopover
          content={
            rightIconPopoverMessage ? (
              <PlainTextPopover>{rightIconPopoverMessage}</PlainTextPopover>
            ) : null
          }
        >
          <Icon iconName={rightIconName} />
        </WithUncontrolledPopover>
      )}
    </TabLabelWrapper>
  ),
  name: `${tabId}`,
  clickId,
  isSelected: tabId === activeTabId,
  onClick: () => onTabChange?.(tabId),
  type: DropdownOptionType.OPTION,
});
